<template lang="pug">
  .height-100
    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalAdjuntar"
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      )
        upload-multi-file(
          name="adjuntar_contratos_manuales",
          folder="contratos-sin-firmar",
          :onlyPdf="true",
          @save="guardarAdjuntos",
          @close="closeModalAdjuntar"
        )
          span(slot="title") Adjunte los pdf de las contratos
          span(slot="explanation") Recuerda que los archivos deben tener el DNI al inicio del nombre del archivo
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionEliminarTodo"
      )
      confirmar-accion-overlay(
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
        @close="mostrarConfirmacionEliminarTodo = false"
        @do="eliminar(null,null,true)"
      )
        span(slot="title") ¿Desea eliminar todas los contratos cargados?
        span(slot="primaryAction")
          span(v-if="isProcessing") Eliminando...
          span(v-else) Eliminar todo
        strong Solo se eliminaran los contratos de la carga manual actual, no las generadas
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionEliminar"
      )
      confirmar-accion-overlay(
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
        @close="mostrarConfirmacionEliminar = false"
        @do="eliminar(contrato.id,contrato)"
      )
        span(slot="title") ¿Está seguro que desea eliminar?
        span(slot="primaryAction")
          span(v-if="isProcessing") Eliminando...
          span(v-else) Eliminar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionEnviarContratos"
      )
      confirmar-accion-overlay(
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
        @close="mostrarConfirmacionEnviarContratos = false"
        @do="enviarContratos"
      )
        span(slot="title") ¿Desea enviar los contratos cargados?
        span(slot="primaryAction")
          span(v-if="isProcessing") Enviando...
          span(v-else) Enviar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarErroresMultiples"
      )
      errores-multiples(
        :errores="messages",
        @close="mostrarErroresMultiples = false"
      )

    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-lista")
        .title
          span Carga manual de contratos
        .display-flex.filtros-completos.jce
          .text-right.media-pt-10
            button.button.is-small.margin-right-5.is-primary(@click="openModalAdjuntar")
              span.icon.is-small
                i.fa.fa-upload.fs-12
              span Adjuntar
            button.button.is-small(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh.fa-fw.fa-lg
              span Refrescar

        div.mt-15
          .text-right.acciones-superior
            button.button.is-small.ml-5.mt-5.is-primary(
              @click="confirmacionEnviarContratos"
              :disabled="lista.length === 0 || isLoading"
              )
              span.icon.is-small.fs-13
                i.fa.fa-envelope.fa-fw.fa-lg
              span Enviar contratos
            button.button.is-small.is-danger.ml-5.mt-5(@click="mostrarConfirmacionEliminarTodo = true", :disabled="lista.length === 0 || isLoading")
              span.icon.is-small
                i.fa.fa-times.fa-fw.fa-lg
              span Eliminar todo
        .body
          .is-loading(v-if="isLoading")
            .icon
              i.fa.fa-spinner.fa-spin
          .information(v-else)
            template(v-if="lista.length !== 0")
              .is-desktop
                table.table.is-striped.is-bordered
                  thead
                    th Empleado
                    th Nombre de archivo
                    th Datos Contratos
                    th Acciones
                  tbody(
                    name="table-row"
                    is="transition-group"
                  )
                    tr.row-table(
                      v-for="(o, index) in lista"
                      :key="index"
                      :class="{'is-close': o.isBGRed}"
                    )
                      td
                        template(v-if="o.codigoEmpleado")
                          .d-initial
                            strong DNI:&nbsp;
                            span {{ o.dniObtenido }}
                          .display-flex.hint--bottom(:aria-label="'Empleado: '+ o.codigoEmpleado")
                            span.name {{ o.nombre }}
                            .cursor-pointer.ml-5(title="Desasignar empleado")
                              i.fa.fa-times(
                                @click="deasignarEmpleadoContratoAuxiliar(o)"
                              )
                        template(v-else)
                          div.position-relative
                            .control.display-flex.align-items-center
                              input.input(
                                type="number",
                                v-model="o.codigoEmpleado"
                              )
                              span.icon.cursor-pointer.margin-left-5(@click="o.mostrarBusquedaEmpleado = true")
                                i.fa.fa-search
                            transition(name="fade-quick")
                              .pop-over(
                                  v-if="o.mostrarBusquedaEmpleado"
                                )
                                  lookup-small-empleado(
                                    @selected="asignarEmpleadoContratoAuxiliar(o, $event)"
                                    @close="o.mostrarBusquedaEmpleado = false"
                                    :codigo="o.codigoEmpleado"
                                  )
                      td
                        div {{ o.namefile }}
                        .d-initial.mt-10
                          strong Modificado:&nbsp;
                          span {{ o.modificado }}
                      td
                        .flex.fdc
                          .control
                            input.checkbox(type="checkbox", :checked="o.indeterminado", @change="check(o)")
                            label &nbsp;Indeterminado
                          hr.margin-05-rem
                          .control
                            label.label.date-input Inicio
                            input.input(type="date", v-model="o.fechaInicio", :disabled="o.indeterminado" @blur="checkDates(o)")
                          .control
                            label.label.date-input Fin
                            input.input(type="date", v-model="o.fechaFin" :disabled="o.indeterminado" @blur="checkDates(o)")
                      td.text-center
                        .contenedor-acciones.fdc
                          a.margin-acciones.button.is-small(v-if="o.ruta", :href="o.ruta", target="_blank")
                            span.icon.is-small
                              i.fa.fa-paperclip.is-small.fs-12
                            span Ver adjunto
                          button.margin-acciones.button.is-small.is-danger(@click="confirmarEliminar(o.id, o)")
                            span.icon.is-small
                              i.fa.fa-times
                            span Eliminar
                          button.margin-acciones.button.is-small(@click="verVistaPrevia(o)")
                            span.icon.is-small
                              i.fa.fa-eye
                            span Vista previa
              .is-mobile
                loading(v-if="isLoading")
                .box(
                  v-for="(o, index) in lista"
                  :key="index"
                  :class="{'is-close': !o.codigoEmpleado || o.isBGRed}"
                )
                  template(v-if="o.codigoEmpleado")
                    div
                      strong DNI:&nbsp;
                      span {{ o.dniObtenido }}
                    .descripcion-tipo.display-flex
                      span.hint--top(:aria-label="'Empleado: ' + o.id") {{ o.nombre }}
                      .cursor-pointer.ml-5(title="Desasignar empleado")
                        i.fa.fa-times(
                          @click="deasignarEmpleadoContratoAuxiliar(o)"
                        )
                  template(v-else)
                    .mb-10
                      .position-relative
                        .control.display-flex.align-items-center
                          input.input(
                            type="number",
                            v-model="o.codigoEmpleado"
                          )
                          span.icon.cursor-pointer.margin-left-5(@click="o.mostrarBusquedaEmpleado = true")
                            i.fa.fa-search
                        transition(name="fade-quick")
                          .pop-over(
                              v-if="o.mostrarBusquedaEmpleado"
                            )
                              lookup-small-empleado(
                                @selected="asignarEmpleadoContratoAuxiliar(o, $event)"
                                @close="o.mostrarBusquedaEmpleado = false"
                                :codigo="o.codigoEmpleado"
                              )
                  .motivo
                    span {{ o.namefile }}
                  .dias-pedidos.mt-5
                    strong Fecha de modificación:&nbsp;
                    div {{ o.modificado }}
                    .flex.fdc
                      .control
                        input.checkbox(type="checkbox", :checked="o.indeterminado", @change="check(o)")
                        label &nbsp;Indeterminado
                      hr.margin-05-rem
                      .control
                        label.label.date-input Inicio
                        input.input(type="date", v-model="o.fechaInicio", :disabled="o.indeterminado" @blur="checkDates(o)")
                      .control
                        label.label.date-input Fin
                        input.input(type="date", v-model="o.fechaFin" :disabled="o.indeterminado" @blur="checkDates(o)")
                  .botones
                    a.button.margin-acciones.is-small(v-if="o.ruta", :href="o.ruta", target="_blank")
                      span.icon.is-small
                        i.fa.fa-paperclip.is-small.fs-12
                      span Ver adjunto
                    button.button.is-small.is-danger.margin-acciones(@click="confirmarEliminar(o.id, o)")
                      span.icon.is-small
                        i.fa.fa-times
                      span Eliminar
                    button.margin-acciones.button.is-small(@click="verVistaPrevia(o)")
                      span.icon.is-small
                        i.fa.fa-eye
                      span Vista previa
          div(v-else)
            .message.is-warning
              .message-body No hay contratos cargados
</template>

<script>
import UploadMultiFileComponent from '../components/c_upload_multi_files'
import LookupSmallEmpleado from '../components/Component_Lookup_Small_Empleado'
import { apiGet, apiPost, apiDelete, notify, apiPut } from '../util/general'
import ComponentErroresMultiples from '../components/Component_Errores_Multiples'
import ConfirmarAccionOverlayComponent from '../components/Component_Confirmar_Accion_Overlay'
import Spinner from 'vue-simple-spinner'
export default {
  name: 'contratos-carga-manual',
  data () {
    return {
      lista                             : [],
      messages                          : [],
      isLoading                         : false,
      mostrarModalAdjuntar              : false,
      cantidadAvance                    : 0,
      cantidadTotal                     : 0,
      filesAdjuntos                     : [],
      isVerifying                       : false,
      isSaving                          : false,
      mostrarConfirmacionEliminar       : false,
      mostrarConfirmacionEliminarTodo   : false,
      mostrarConfirmacionEnviarContratos: false,
      mostrarModalPosicionFirma         : false,
      periodo                           : '',
      mes                               : '',
      tipo                              : '',
      descripcionTipo                   : '',
      isProcessing                      : false,
      tipos                             : [],
      mostrarErroresMultiples           : false,
      contrato                          :{
        index: '',
        pagina_auxiliar : '',
        x_auxiliar      : '',
        y_auxiliar      : '',
        posicion_firma  : []
      }
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  components: {
    'upload-multi-file': UploadMultiFileComponent,
    Spinner,
    LookupSmallEmpleado,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent,
    'errores-multiples': ComponentErroresMultiples
  },
  destroyed () {
    // Remover el event listener cuando el componente se destruya
    window.removeEventListener('resize', this.handleResize);
  },
  mounted () {
    this.fetch()
    // Agregar el event listener cuando el componente se monte
    window.addEventListener('resize', this.handleResize);
    // Llamar al método por si ya está en tamaño menor a 800px al cargar
    this.handleResize();
  },
  methods: {
    verVistaPrevia (o) {
      var vm = this
      var obj = {
        id: o.id
      }
      apiGet(vm, '/contratos/auxiliar/vista-previa', obj, function (data) {
        window
          .open(data.ruta, '_blank')
          .focus()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    handleResize () {
      if (window.innerWidth <= 820) {
        this.$store.dispatch('setSidebarDesktop', true)
        localStorage.setItem('sidebar-show', true)
      } else if (window.innerWidth < 1140) {
        this.$store.dispatch('setSidebarDesktop', false)
        localStorage.setItem('sidebar-show', false)
      }
    },
    checkDates (o) {
      if (o.fechaFin && o.fechaInicio) {
        this.handleBothDatesSet(o);
      }
    },
    handleBothDatesSet (o) {
      var vm = this
      // valido que o.fechaInicio sea menor a o.fechaFin
      if (o.fechaInicio > o.fechaFin) {
        notify(this, 'warning', 'Advertencia', 'La fecha de inicio debe ser menor a la fecha de fin')
        o.fechaInicio = ''
        o.fechaFin = ''
        o.isBGRed = true
        return
      } else if (o.fechaInicio === o.fechaFin) {
        notify(this, 'warning', 'Advertencia', 'La fecha de inicio no puede ser igual a la fecha de fin')
        o.fechaInicio = ''
        o.fechaFin = ''
        o.isBGRed = true
        return
      }
      o.isBGRed = false
      vm.asignarDatosContrato(o)
    },
    check (o) {
      var vm = this
      o.indeterminado = !o.indeterminado
      o.isBGRed = !o.indeterminado
      if (o.indeterminado === true) {
        o.fechaInicio = ''
        o.fechaFin = ''
      }
      vm.asignarDatosContrato(o)
    },
    fetch () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/contratos/auxiliar', obj, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    openModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = true
    },
    closeModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = false
    },
    guardarAdjuntos (files) {
      var vm = this
      var obj = {
        archivos: files.map(file => {
          if (file.status === 1) {
            return file.file
          }
        })
      }
      apiPost(vm, '/contratos/auxiliar', obj, function (data) {
        if (data.status === 2) {
          // mostrar errores multiples
          vm.mostrarErroresMultiples = true
          vm.messages = data.messages
        } else if (data.status === 1) {
          notify(vm, 'success', 'Éxito', data.message)
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.fetch()
        vm.closeModalAdjuntar()
      })
    },
    confirmarEliminar (id, o) {
      var vm = this;
      vm.mostrarConfirmacionEliminar = true;
      vm.contrato = o;
    },
    eliminar (id, o, isTodos = false) {
      var vm = this
      if (!isTodos && o.isRemoving) return
      else if (isTodos && vm.isLoading) return

      var obj = { ids : [] }

      if (isTodos) {
        obj.ids = vm.lista.map(item => +item.id)
        vm.isLoading = true
      } else {
        obj.ids = [+id]
        o.isRemoving = true
      }
      apiDelete(vm, '/contratos/auxiliar', obj, function (data) {
        if (data.status === 2) {
          notify(vm, 'warning', 'Advertencia', data.messageError)
          notify(vm, 'warning', 'Advertencia', data.message)
        } else if (data.status === 1) {
          notify(vm, 'success', 'Éxito', data.message)
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        if (!isTodos) o.isRemoving = false
        else vm.isLoading = false
        vm.mostrarConfirmacionEliminarTodo = false
        vm.mostrarConfirmacionEliminar = false
        vm.fetch()
      })
    },
    asignarEmpleadoContratoAuxiliar (o, empleado) {
      var vm = this
      var obj = {
        id     : o.id,
        codigoEmpleado : empleado.codigo
      }
      apiPut(vm, '/contratos/auxiliar/asignarEmpleado', obj, function (data) {
        notify(vm, 'success', 'Éxito', data.message)
        o.codigoEmpleado = empleado.codigo
        o.nombre         = empleado.nombre
        o.dniObtenido    = empleado.dni
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.fetch()
      })
    },
    deasignarEmpleadoContratoAuxiliar (o) {
      var vm = this
      var obj = {
        id     : o.id
      }
      apiPut(vm, '/contratos/auxiliar/deasignarEmpleado', obj, function (data) {
        notify(vm, 'success', 'Éxito', data.message)
        o.codigoEmpleado      = ''
        o.nombre      = ''
        o.dniObtenido = ''
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.fetch()
      })
    },
    asignarDatosContrato (o) {
      var vm = this
      var obj = {
        indeterminado : o.indeterminado,
        fechaInicio   : o.fechaInicio,
        fechaFin      : o.fechaFin,
        id: o.id
      }
      apiPut(vm, '/contratos/auxiliar/asignarDatosContrato', obj, function (data) {
        notify(vm, 'success', 'Éxito', data.message)
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        if (vm.isSaving) vm.cerrarModalPosicionFirma()
        vm.fetch()
      })
    },
    enviarContratos () {
      var vm = this
      // notify(vm, 'warning', 'Advertencia', 'Exitos')
      var obj = { ids : [] }
      obj.ids = vm.lista.map(item => +item.id)
      apiPost(vm, '/contratos/auxiliar/enviar', obj, function (data) {
        if (data.status === 2) {
          // mostrar errores multiples
          vm.mostrarErroresMultiples = true
          vm.messages = data.messages
        } else if (data.status === 1) {
          notify(vm, 'success', 'Éxito', data.message)
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.fetch()
        vm.mostrarConfirmacionEnviarContratos = false
        apiGet(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
          vm.$store.dispatch('setContratosPorFirmar', data.lista.filter(a => !a.firmado).length)
        })
      })
    },
    confirmacionEnviarContratos () {
      var vm = this
      // verificamos que tengan todos los datos llenos
      for (var i = 0; i < vm.lista.length; i++) {
        if (!vm.lista[i].codigoEmpleado) {
          notify(vm, 'warning', 'Advertencia', 'Debe asignar un empleado a todos los contratos')
          return
        } else if (vm.lista[i].isBGRed) {
          notify(vm, 'warning', 'Advertencia', 'Debe asignar una duracion a todos los contrato')
          return
        }
      }
      vm.mostrarConfirmacionEnviarContratos = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .acciones-superior
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
  .margin-acciones
    margin 3px 5px !important
  .is-mobile
    .is-close
      background-color: #ffd6d6 !important;

  .d-initial
    display initial !important
  .date-input
    font-weight 400 !important;
    margin-bottom 1px !important;
  .margin-05-rem
    margin 0.5rem 0;
  .fs-12
    font-size 12px  !important
  .bg-red
    background-color:#ffd6d6
  .botones
    display flex
    justify-content center
    margin-top 10px
    .button
      margin-right 5px
      &:last-child
        margin-right 0px
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px
  .button.is-loading
    margin-top 0px


  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .contenedor-acciones
    padding-top 4px
    display flex
    .button
      flex 1
      margin 0px 5px
  td.text-center
    span.no-accion
      font-size: 12px
  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde

  .small
    font-size: 12px;
    color: #9a9a9a;

  .big
    font-size: 28px;
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);

  .show-break-1
    display none

  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
      justify-content center
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      width: 100%;
      padding-top: 5px;
      padding-bottom: 5px;
    .botones
      display flex
      justify-content center
      flex-wrap wrap
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .show-break-2
    display none

  @media (max-width: 1003px)
    .show-break-2
      display initial

    .hide-break-2
      display none !important


  @media (max-width: 900px)
    .show-break-1
      display initial

    .hide-break-1
      display none


  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width: 720px)
    .is-desktop
      display none

    .is-mobile
      display block

    .filtro-input
      flex-direction column
  @media (max-width: 500px)
    .filtros-completos
      flex-direction column

  @media (max-width: 450px)
    .media-pt-10
      padding-top 10px

</style>




// WEBPACK FOOTER //
// View_Contratos_Carga_Manual.vue?f85dc67c